import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app-core/services/auth/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent implements OnInit {
  public access;
  public smallDevice = false;
  @Input() avatar: string;

  public isMobile;
  public isTablet;
  public isDesktopDevice;

  constructor(
    private service: AuthService,
    private deviceService: DeviceDetectorService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
    this.access = storedPermissions.includes('Admin');
    this.deviceFunction();
  }

  selectApp(): void {
    this.service.goToApp();
  }
  deviceFunction() {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  public logout(): void {
    this.service.logout();
  }

  public goToProfile() {
    this.router.navigate(['profile']);
  }
}
